import React from 'react';
export class ProductTableUI extends React.Component {
    constructor(props) {
        super(props);

        this.onViewClick = this.onViewClick.bind(this);
        this.onPrizeClick = this.onPrizeClick.bind(this);

    }
    onViewClick(e) {
        //   console.log("view click");
        if (typeof this.props.onViewClick === "function") {
            this.props.onViewClick(e);

        }
    }


    onPrizeClick(e) {

        //     console.log("prize click");
        if (typeof this.props.onPrizeClick === "function") {
            this.props.onPrizeClick(e);
        }
    }


    render() {
        console.log(this.props.data);

        if (this.props.data != null && this.props.data.length > 0) {
            var Rows = this.props.data.map(
                (data) =>

                    <tr >
                        
                        <td>
                            {data.ghoreName}
                        </td>
                        <td>
                            {data.productId}
                        </td>
                        <td>
                            {data.productName}
                        </td>

                       
                        <td>
                            {data.productCatId}
                        </td>


                        <td>
                            {data.productCatName}
                        </td>



                        <td>
                            {data.totalCount}
                        </td>



                        <td>
                            {data.distinctMobile}
                        </td>


                        <td>
                            {data.point}
                        </td>



                    </tr>



            );
        }
        else {
            Rows = <tr><td colSpan="3">سطری وجود ندارد</td></tr>;
        }

        return (
            <div className="col-lg-12">
                <div className="">

                    <div className="table-responsive ">
                        <table className="table  table-striped text-center">
                            <thead>
                                <tr>
                                    <th >
                                        نام قرعه کشی
                                    </th>
                                    <th>
                                        کد محصول
                                </th>
                                    <th>
                                        نام محصول
                                </th>

                                    <th>
                                        کد دسته
                                </th>

                                    <th>
                                        نام دسته
                                </th>


                                    <th>
تعداد کد موفق                                    </th>

                                    <th>
تعداد شرکت کنندگان                                    </th>

                                    <th>
                                        امتیاز
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {Rows}
                            </tbody>
                        </table>
                    </div>

                </div>

            </div>
        );

    }
}
/*
function printPrice(x) {


    // console.log("x:" + x);
    if (typeof (x) == "undefined")
        return "";

    if (x == null || x === "")
        return "";

    x = parseInt(x);

    return MytoLocaleString(x);
}

function MytoLocaleString(s) {

    var s1 = s.toLocaleString();
    var p = new Number(Math.floor(s) + 0.1);    // similar value but decimal
    var p1 = p.toLocaleString();
    var index;
    var point;
    for (index = p1.length - 1; index > 0; index--) { // find decimal point in dummy
        point = p1.charAt(index);
        if (point < '0' || point > '9')
            break;
    }
    if (index > 0) {
        index = s1.lastIndexOf(point);          // find last point in string
        if (index > 0)
            s1 = s1.slice(0, index);            // truncate decimal part

        return s1;
    }
    return "";
}
*/


// WEBPACK FOOTER //
// ./src/tables/product/ProductTableUI.js